// Tiny shared types + helpers for the React app.
import type { ReportStatus } from '@/api/types';

export const REPORT_STATUS_LABEL: Record<ReportStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  archived: 'Archived',
  deleted: 'Deleted',
};

export const REPORT_STATUS_TONE: Record<ReportStatus, string> = {
  draft: 'pill pill--draft',
  submitted: 'pill pill--submitted',
  archived: 'pill pill--archived',
  deleted: 'pill pill--deleted',
};

export const SHARE_VISIBILITY_LABEL: Record<'friends' | 'link' | 'private' | 'public', string> = {
  friends: 'Friends',
  link: 'Anyone with the link',
  public: 'Public',
  private: 'Private',
};

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const diff = (Date.now() - date.getTime()) / 1000;
  if (Math.abs(diff) < 60) return 'just now';
  const minutes = Math.round(diff / 60);
  if (Math.abs(minutes) < 60) return `${minutes}m ago`;
  const hours = Math.round(diff / 3600);
  if (Math.abs(hours) < 24) return `${hours}h ago`;
  const days = Math.round(diff / 86400);
  if (Math.abs(days) < 30) return `${days}d ago`;
  return date.toLocaleDateString();
}
